// Core
import React from 'react';
import PropTypes from 'prop-types';

// Style
import './styles.scss';

// Assets
import SearchIcon from '@mui/icons-material/Search';
import { useTranslation } from 'react-i18next';


const Banner = (props) => {
    const { title, decription, placeholder, image, handleOnClick, withSearch, handleOnChange, onKeyDown, value, radioOptions, selectedRadio, handleRadioChange, ...rest } = props;
    const onChangeHandle = (e) => handleOnChange?.(e.target.value);

    const { t } = useTranslation();
    
    const onRadioClick = (val) => {
        if (selectedRadio === val) {
            handleRadioChange(null);
        } else {
            handleRadioChange(val);
        }
    }
    return (
        <div className='__comm_banner_se'>
            <img src='https://ibnbatuta.ae/banner.webp' alt={title}/>
            <h1>{title}</h1>
            <p>{decription}</p>
            {
                withSearch ?
                    <div className='__input_sec'>
                        <input type="text" placeholder={placeholder} onChange={onChangeHandle} value={value} onKeyDown={onKeyDown}/>
                        <button onClick={handleOnClick}><SearchIcon fontSize="large" /></button>
                    </div>
                    : ''
            }
            {
                radioOptions && radioOptions.length > 0 ?
                    <div className='__radio_sec'>
                        {
                            radioOptions.map((item, index) => (
                                <div key={index} className='__radio_item' onClick={() => onRadioClick(item.value)}>
                                    <div className={`__radio_circle ${selectedRadio === item.value ? 'active' : ''}`}>
                                        <div className='__inner_circle'></div>
                                    </div>
                                    <span>{t(item.text)}</span>
                                </div>
                            ))
                        }
                    </div>
                    : ''
            }
        </div>

    );
};

export default Banner;

Banner.propTypes = {
    title: PropTypes.string,
    decription: PropTypes.string,
    placeholder: PropTypes.string,
    image: PropTypes.string,
    withSearch: PropTypes.bool,
    handleOnClick: PropTypes.func,
    onKeyDown: PropTypes.func,
    handleOnChange: PropTypes.func,
    radioOptions: PropTypes.array,
    selectedRadio: PropTypes.number,
    handleRadioChange: PropTypes.func
};
